const ScheduleToggleSection = ({
  isScheduleChecked,
  setIsScheduleChecked,
  isScheduleRequired,
}) => {
  if (isScheduleRequired) return null;

  return (
    <div className="my-auto flex">
      <label className="relative inline-flex items-center cursor-pointer my-auto">
        <input
          type="checkbox"
          onChange={() => setIsScheduleChecked(!isScheduleChecked)}
          className="sr-only peer"
          checked={isScheduleChecked}
        />
        <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-200 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-yellow-500" />
      </label>
    </div>
  );
};

export default ScheduleToggleSection;
